<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <template v-if="isAdmin">
          <sidebar-link to="/adminDashboard" :name="$t('sidebar.dashboard')" icon="ti-panel" />
          <sidebar-link to="/usersAdmin" :name="$t('sidebar.userProfile')" icon="ti-user"/>
        </template>

        <template v-else>
          <sidebar-link to="/dashboard" :name="$t('sidebar.dashboard')" icon="ti-panel" />
          <sidebar-link to="/stats" :name="$t('sidebar.userProfile')" icon="ti-user"/>
          <sidebar-link to="/edit-qr" :name="$t('sidebar.qrEdit')" icon="ti-view-grid" />
          <sidebar-link to="/edit-bank-billing" :name="$t('sidebar.bankBilling')" icon="ti-money" />
          <sidebar-link to="/social-and-pages" :name="$t('sidebar.accountsPages')" icon="ti-instagram" />
          <sidebar-link to="/edit-user-preview" :name="$t('sidebar.editCardPreview')" icon="ti-layout" />
        </template>


        <sidebar-link to="/logout" :name="$t('sidebar.exit')" icon="ti-shift-right" />
      </template>

      <mobile-menu>
        <li class="nav-item">
          <div class="settings-dropdown">
            <a href="#" class="settings-trigger" @click.prevent="toggleSettings">
              <i class="ti-settings"></i>
              <span>{{ $t('sidebar.settings') }}</span>
              <i :class="['ti-angle-down', { 'rotate': showSettings }]"></i>
            </a>

            <transition name="fade">
              <div v-show="showSettings" class="settings-submenu">
                <a href="#" @click.prevent="openChangePasswordModal">
                  <i class="ti-lock"></i>
                  {{ $t('settings.changePass') }}
                </a>
                <div class="language-section">
                  <a href="#" @click.prevent="toggleLanguage">
                    <i class="ti-world"></i>
                    {{ $t('settings.changeLang') }}
                    <i :class="['ti-angle-down', { 'rotate': showLanguage }]"></i>
                  </a>
                  <div v-show="showLanguage" class="language-options">
                    <a href="#" @click.prevent="setLocale('tr')">Türkçe</a>
                    <a href="#" @click.prevent="setLocale('en')">English</a>
                    <a href="#" @click.prevent="setLocale('de')">Deutsch</a>
                  </div>
                </div>
              </div>
            </transition>
          </div>

        </li>
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>

    <!-- Password Change Modal -->
    <div v-if="showPasswordModal" class="modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="ti-lock"></i> {{ $t('settings.changePass') }}</h5>
            <button type="button" class="close" @click="closeChangePasswordModal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="changePassword">
              <div class="form-group">
                <label>{{ $t('settings.oldPass') }}</label>
                <input type="password" v-model="oldPassword" class="form-control" required />
              </div>
              <div class="form-group">
                <label>{{ $t('settings.newPass') }}</label>
                <input type="password" v-model="newPassword" class="form-control" required />
              </div>
              <div class="form-group">
                <label>{{ $t('settings.confirmPass') }}</label>
                <input type="password" v-model="confirmPassword" class="form-control" required />
              </div>
              <button type="submit" class="btn btn-primary">{{ $t('settings.changePass') }}</button>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar"></dashboard-content>
      <content-footer></content-footer>
    </div>
  </div>
</template>

<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import axios from "axios";
import config from "@/routing_map.json";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  data() {
    return {
      isAdmin: false,
      showSettings: false,
      showLanguage: false,
      showPasswordModal: false,
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    toggleSettings() {
      this.showSettings = !this.showSettings;
      if (!this.showSettings) {
        this.showLanguage = false;
      }
    },
    toggleLanguage() {
      this.showLanguage = !this.showLanguage;
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem('locale', locale);
    },
    checkUserRole() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
      this.isAdmin = userInfo.role === 'admin'
    },
    openChangePasswordModal() {
      this.showPasswordModal = true;
      this.showSettings = false;
    },
    closeChangePasswordModal() {
      this.showPasswordModal = false;
      this.oldPassword = '';
      this.newPassword = '';
      this.confirmPassword = '';
    },
    changePassword() {
      if (this.newPassword !== this.confirmPassword) {
        this.notifyVue('top', 'right', this.$t('settings.passwordsDoNotMatch'), "warning");
        return;
      }

      const passwordData = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword
      };

      axios.defaults.headers.common.authorization = localStorage.getItem('authorization');
      axios.post(`${config.app_url}/login/update-password`, passwordData)
        .then(response => {
          if (response.data.success) {
            this.notifyVue('top', 'right', this.$t('settings.passwordChanged'), "success");
            this.closeChangePasswordModal();
          } else {
            this.notifyVue('top', 'right', this.$t('settings.incorrectInf'), "warning");
          }
        })
        .catch(() => {
          this.notifyVue('top', 'right', this.$t('settings.errorOccurred'), "warning");
        });
    },
    notifyVue(verticalAlign, horizontalAlign, message, type) {
      this.$notify({
        component: NotificationTemplate,
        title: message,
        icon: "info",
        horizontalAlign,
        verticalAlign,
        type,
        duration: 2000
      });
    }
  },
  mounted() {
    this.checkUserRole()
  }
};
</script>

<style scoped>
.settings-dropdown {
  position: relative;
  margin: 10px 15px;
}

.settings-trigger {
  display: flex;
  align-items: center;
  padding: 10px;
  color: #ffffff;
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.settings-trigger:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.settings-submenu {
  background: #2c2c2c;
  border-radius: 4px;
  margin-top: 5px;
}

.settings-submenu a {
  display: flex;
  align-items: center;
  padding: 10px;
  color: #ffffff;
  text-decoration: none;
}

.settings-submenu a:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.settings-submenu i {
  margin-right: 10px;
}

.language-options {
  background: #383838;
  padding: 5px 0;
}

.language-options a {
  padding-left: 30px;
}

.rotate {
  transform: rotate(180deg);
  transition: transform 0.3s;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-dialog {
  width: 100%;
  max-width: 500px;
}

.modal-content {
  background: white;
  border-radius: 8px;
  padding: 20px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
